export default __webpack_public_path__ + "static/media/google-drive.dc5af357.png";